// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 6734 ? "mod-academics" : chunkId) + "." + {"2273":"2117a594","6734":"428b4b06"}[chunkId] + ".chunk.css";
};